import { uuid } from './uuid'
import { getCookieValue, setUvCookie } from './cookie'
import { formatTimer } from './str'
import { postSdkOwnError } from '../post-sdk-own-error';

/**
 * 设置 uv 到本地存储
 * @param {string} opts
 * @param {string} [customId]
 * @return {string} 
 */
 export function setUvStorage (opts, customId) {
   try {
    const id = customId ? customId : uuid();
    let value = id + '.' + formatTimer(new Date());
    let eventid = opts?.common?.eventid;
    // 针对 eventid / appid 为空的情况，对用户进行 warn 提示，并把配置项打印出来
    if (!eventid || !opts.appid) {
      console.warn('eventid or appid is not defined\n', opts);
    }
    eventid = eventid ? eventid + '_' : '';
    const keyName = 'tlog_u_' + eventid + opts.appid
    if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
      localStorage.setItem(keyName, value)
    } else if (navigator.cookieEnabled) {
      setUvCookie(keyName, value)
    }
    return value
  } catch (error) {
    postSdkOwnError(error, opts.baseURL)
    return ''
  }
}

/**
 * 从本地存储获取 uv
 * @param {string} opts
 * @return {string} 
 */
export function getUvStorage (opts) {
  try {
    let eventid = opts?.common?.eventid;
    // 针对 eventid / appid 为空的情况，对用户进行 warn 提示，并把配置项打印出来
    if (!eventid || !opts.appid) {
      console.warn('eventid or appid is not defined\n', opts);
    }
    eventid = eventid ? eventid + '_' : '';
    const keyName = 'tlog_u_' + eventid + opts.appid
    if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
      return localStorage.getItem(keyName);
    } else if (navigator.cookieEnabled) {
      return getCookieValue(keyName);
    } else {
      return ''
    }
  } catch (error) {
    postSdkOwnError(error, opts.baseURL)
    return ''
  }
}
